<script>
	import { createEventDispatcher, getContext } from 'svelte'
	import { styles } from '../library/scripts/styles.js'
	export let title

	const globals = getContext('globals')
	const modalContent = globals.modalContent
	const modalHeader = globals.modalHeader
	const icon = globals.iconSmall
	const fsL = globals.fsL
	const colorMain = globals.colorMain
	const bgDark = globals.bgDark
	const inputBg = globals.inputBg
	const inputBorder = globals.inputBorder
	const colorError = globals.colorError
	const colorOK = globals.colorOK

	export let modalWidth = globals.modalWidth
	const navBg = globals.navBg

	let visible = true

	const dispatch = createEventDispatcher()

	const close_window = () => {
		dispatch('closemodal', { name: 'modal' })
		visible = false
	}
</script>

{#if visible}
	<div class="container" use:styles={{ modalWidth, inputBg }}>
		<div class="header" use:styles={{ modalHeader, navBg }}>
			<div use:styles={{ fsL, colorMain }} class="title">{title}</div>
			<div
				class="icon"
				use:styles={{ icon, inputBg, bgDark, inputBorder, colorError, colorOK }}
				on:click={close_window}
				on:keydown={close_window}
			/>
		</div>
		<div class="content" use:styles={{ modalContent, bgDark }}>
			<slot name="content" />
		</div>
	</div>
{/if}

<style>
	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: var(--modalWidth);
		height: var(--modalContent);
		background-color: transparent;
		user-select: none;
		border: 1px solid white;
	}

	.header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: var(--modalHeader);
		background-color: transparent;
		padding: 0 2% 0 2%;
		border-top: 1px solid var(--inputBg);
	}

	.title {
		width: 100%;
		display: flex;
		justify-content: center;
		color: hsl(0, 0%, 100%);
		font-size: var(--fsL);
		font-weight: 300;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		border-radius: 2px;
		cursor: pointer;
	}

	.icon::after,
	.icon::before {
		content: '';
		display: block;
		width: var(--icon);
		background: white;
		margin-top: -3px;
		height: 3px;
		cursor: pointer;
	}

	.icon::before {
		-webkit-transform: rotate(-45deg);
		-ms-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}
	.icon::after {
		-webkit-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.icon:hover::after,
	.icon:hover::before {
		background-color: var(--colorError);
	}

	.content {
		background-color: transparent;
		width: 100%;
		height: var(--modalContent);
	}
</style>
